export type TestStatus = 'idle' | 'running' | 'green' | 'yellow' | 'red' | 'offline';
export type StepStatus = 'idle' | 'running' | 'success' | 'failed';

export type RttValue = number | { average: number };

export interface TwilioTurnReport {
  rtt?: RttValue;
  availableRelay?: boolean;
  transport?: 'udp' | 'tcp';
}

export interface TwilioBitrateReport {
  codec?: string;
  rtt?: RttValue;
}

export interface TwilioDiagnosticsTest {
  start: () => void;
  on: {
    (event: 'error', listener: (error: Error) => void): void;
    (event: 'end', listener: (report: TwilioTurnReport | TwilioBitrateReport) => void): void;
  };
}

export interface TwilioDiagnosticsFactory {
  testBitrate: (options: { iceServers: Array<{ urls: string }> }) => TwilioDiagnosticsTest;
  testTurnConnectivity: (options: {
    iceServers: Array<{ urls: string }>;
  }) => TwilioDiagnosticsTest;
}

export interface IceServerItem {
  urls: string | string[];
  url?: string;
  username?: string;
  credential?: string;
}

export type IceServerArray = IceServerItem[];